import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BaseListagem, { BaseListagemRef } from "components/BaseListagem";
import ModalDocumentoResponderSolicitacaoRevisao from "components/modal/documentos/solicitacao/ModalDocumentoResponderSolicitacaoRevisao";
import ModalDocumentoVerSolicitacaoRevisao from "components/modal/documentos/solicitacao/ModalDocumentoVerSolicitacaoRevisao";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import DocumentoSolicitacaoRevisao from "model/documentos/DocumentoSolicitacaoRevisao";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DocumentoService from "service/documentos/DocumentoService";
import DocumentoSolicitacaoRevisaoService from "service/documentos/DocumentoSolicitacaoRevisaoService";
import { converterDataHora } from "utils/convert";
import { IdMatchModeOptions, ListMatchModeOptions, TextMatchModeOptions, dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, statusFilterTemplate } from "utils/filterUtils";

const documentoSolicitacaoRevisaoService = new DocumentoSolicitacaoRevisaoService();

export default function DocumentoSolicitacaoRevisaoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Solicitações de Revisão');
    const baseListagemRef = useRef<BaseListagemRef>(null);

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [categorias, setCategorias] = useState<CategoriaDocumento[]>([]);
    const [documentoVerSolicitarRevisao, setDocumentoVerSolicitarRevisao] = useState<{ visible: boolean, solicitacao: DocumentoSolicitacaoRevisao | null }>({ visible: false, solicitacao: null });
    const [documentoResponderSolicitarRevisao, setDocumentoResponderSolicitarRevisao] = useState<{ visible: boolean, solicitacao: DocumentoSolicitacaoRevisao | null }>({ visible: false, solicitacao: null });

    useEffect(() => {
        documentoSolicitacaoRevisaoService.categorias().then((response) => {
            setCategorias(response);
        }).catch((error) => {
            console.error("Erro ao buscar categorias:", error);
        })
        documentoSolicitacaoRevisaoService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((error) => {
            console.error("Erro ao buscar categorias:", error);
        })
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        categoria: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        usuarioSolicitacao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataGeracao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        resposta: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    return (
        <>
            {documentoVerSolicitarRevisao.visible ? <ModalDocumentoVerSolicitacaoRevisao
                visible={documentoVerSolicitarRevisao.visible}
                onHide={() => setDocumentoVerSolicitarRevisao({ visible: false, solicitacao: null })}
                solicitacao={documentoVerSolicitarRevisao.solicitacao as DocumentoSolicitacaoRevisao}
            /> : null}
            {documentoResponderSolicitarRevisao.visible ? <ModalDocumentoResponderSolicitacaoRevisao
                visible={documentoResponderSolicitarRevisao.visible}
                onHide={() => setDocumentoResponderSolicitarRevisao({ visible: false, solicitacao: null })}
                solicitacao={documentoResponderSolicitarRevisao.solicitacao as DocumentoSolicitacaoRevisao}
                onConfirm={() => {
                    baseListagemRef.current?.reload();
                    setDocumentoResponderSolicitarRevisao({ visible: false, solicitacao: null });
                }}
            /> : null}
            <BaseListagem
                ref={baseListagemRef}
                ordenacao="dataGeracao,DESC"
                service={documentoSolicitacaoRevisaoService}
                urlService="/documentoSolicitacaoRevisao"
                tituloPagina={titulo}
                defaultFilters={defaultFilters}
                showClearFilterButton
                showNewButton={false}
                showEditButton={false}
                showRemoveButton={false}
                nome="documentoSolicitacaoRevisao" >
                <Column field="documento.codigoInterno" header="Código" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />

                <Column field="documento.nome" header="Titulo" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />

                <Column field="documento.categoria.nome" header="Categoria" filter filterField="categoria" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, categorias)} />

                <Column field="usuarioSolicitacao.nome" header="Usuario solicitação" filter filterField="usuarioSolicitacao" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, usuarios)} />

                <Column field="dataGeracao" header="Dt. Solicitação" body={(rowData: DocumentoSolicitacaoRevisao) => converterDataHora(rowData.dataGeracao)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataGeracao"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                />
                <Column field="resposta" header="Resposta" filterField="resposta"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => statusFilterTemplate(options, documentoSolicitacaoRevisaoService.getRespostasFilter())}
                    body={(rowData) => documentoSolicitacaoRevisaoService.getResposta(rowData.resposta)}
                />
                <Column body={(rowData: DocumentoSolicitacaoRevisao) => <>
                    <Button
                        style={{ marginRight: '0.5em' }}
                        icon="pi pi-eye"
                        onClick={() => { setDocumentoVerSolicitarRevisao({ visible: true, solicitacao: rowData }) }}
                        tooltip="Ver"
                        tooltipOptions={{ position: "top" }} />
                    {!rowData.resposta ? <Button
                        icon={<FontAwesomeIcon icon={'reply'} />}
                        onClick={() => { setDocumentoResponderSolicitarRevisao({ visible: true, solicitacao: rowData }) }}
                        tooltip="Responder"
                        tooltipOptions={{ position: "top" }} /> : null}
                </>} />
            </BaseListagem>
        </>
    )
}